/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { contentsRequestResultControllerCreate } from '../fn/contents-request-result/contents-request-result-controller-create';
import { ContentsRequestResultControllerCreate$Params } from '../fn/contents-request-result/contents-request-result-controller-create';
import { contentsRequestResultControllerDelete } from '../fn/contents-request-result/contents-request-result-controller-delete';
import { ContentsRequestResultControllerDelete$Params } from '../fn/contents-request-result/contents-request-result-controller-delete';
import { contentsRequestResultControllerDownloadAll } from '../fn/contents-request-result/contents-request-result-controller-download-all';
import { ContentsRequestResultControllerDownloadAll$Params } from '../fn/contents-request-result/contents-request-result-controller-download-all';
import { contentsRequestResultControllerFindAll } from '../fn/contents-request-result/contents-request-result-controller-find-all';
import { ContentsRequestResultControllerFindAll$Params } from '../fn/contents-request-result/contents-request-result-controller-find-all';
import { contentsRequestResultControllerFindByContentsRequestId } from '../fn/contents-request-result/contents-request-result-controller-find-by-contents-request-id';
import { ContentsRequestResultControllerFindByContentsRequestId$Params } from '../fn/contents-request-result/contents-request-result-controller-find-by-contents-request-id';
import { contentsRequestResultControllerFindById } from '../fn/contents-request-result/contents-request-result-controller-find-by-id';
import { ContentsRequestResultControllerFindById$Params } from '../fn/contents-request-result/contents-request-result-controller-find-by-id';
import { contentsRequestResultControllerSearchCursor } from '../fn/contents-request-result/contents-request-result-controller-search-cursor';
import { ContentsRequestResultControllerSearchCursor$Params } from '../fn/contents-request-result/contents-request-result-controller-search-cursor';
import { contentsRequestResultControllerSearchOffset } from '../fn/contents-request-result/contents-request-result-controller-search-offset';
import { ContentsRequestResultControllerSearchOffset$Params } from '../fn/contents-request-result/contents-request-result-controller-search-offset';
import { contentsRequestResultControllerUpdate } from '../fn/contents-request-result/contents-request-result-controller-update';
import { ContentsRequestResultControllerUpdate$Params } from '../fn/contents-request-result/contents-request-result-controller-update';
import { ContentsRequestResultDto } from '../models/contents-request-result-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ContentsRequestResultService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contentsRequestResultControllerFindAll()` */
  static readonly ContentsRequestResultControllerFindAllPath = '/api/contents-request-result';

  /**
   * 콘텐츠 의뢰 산출물 전체 조회.
   *
   * 콘텐츠 의뢰 산출물 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerFindAll$Response(params?: ContentsRequestResultControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestResultDto>>> {
    return contentsRequestResultControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 산출물 전체 조회.
   *
   * 콘텐츠 의뢰 산출물 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerFindAll(params?: ContentsRequestResultControllerFindAll$Params, context?: HttpContext): Observable<Array<ContentsRequestResultDto>> {
    return this.contentsRequestResultControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContentsRequestResultDto>>): Array<ContentsRequestResultDto> => r.body)
    );
  }

  /** Path part for operation `contentsRequestResultControllerDownloadAll()` */
  static readonly ContentsRequestResultControllerDownloadAllPath = '/api/contents-request-result/{id}/download';

  /**
   * 모든 파일 다운로드
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerDownloadAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerDownloadAll$Response(params: ContentsRequestResultControllerDownloadAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return contentsRequestResultControllerDownloadAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 파일 다운로드
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerDownloadAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerDownloadAll(params: ContentsRequestResultControllerDownloadAll$Params, context?: HttpContext): Observable<Blob> {
    return this.contentsRequestResultControllerDownloadAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `contentsRequestResultControllerSearchOffset()` */
  static readonly ContentsRequestResultControllerSearchOffsetPath = '/api/contents-request-result/search/offset';

  /**
   * 콘텐츠 의뢰 산출물 오프셋 기반 조회.
   *
   * 콘텐츠 의뢰 산출물을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerSearchOffset$Response(params: ContentsRequestResultControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return contentsRequestResultControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 산출물 오프셋 기반 조회.
   *
   * 콘텐츠 의뢰 산출물을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerSearchOffset(params: ContentsRequestResultControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.contentsRequestResultControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestResultControllerSearchCursor()` */
  static readonly ContentsRequestResultControllerSearchCursorPath = '/api/contents-request-result/search/cursor';

  /**
   * 콘텐츠 의뢰 산출물 커서 기반 조회.
   *
   * 콘텐츠 의뢰 산출물을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerSearchCursor$Response(params: ContentsRequestResultControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return contentsRequestResultControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 산출물 커서 기반 조회.
   *
   * 콘텐츠 의뢰 산출물을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerSearchCursor(params: ContentsRequestResultControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.contentsRequestResultControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestResultControllerFindByContentsRequestId()` */
  static readonly ContentsRequestResultControllerFindByContentsRequestIdPath = '/api/contents-request-result/{contentsRequestId}/contentsRequest';

  /**
   * 콘텐츠 의뢰 ID 기반 조회.
   *
   * 콘텐츠 의뢰 산출물을 콘텐츠 의뢰 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerFindByContentsRequestId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerFindByContentsRequestId$Response(params: ContentsRequestResultControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestResultDto>>> {
    return contentsRequestResultControllerFindByContentsRequestId(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 ID 기반 조회.
   *
   * 콘텐츠 의뢰 산출물을 콘텐츠 의뢰 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerFindByContentsRequestId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerFindByContentsRequestId(params: ContentsRequestResultControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<Array<ContentsRequestResultDto>> {
    return this.contentsRequestResultControllerFindByContentsRequestId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContentsRequestResultDto>>): Array<ContentsRequestResultDto> => r.body)
    );
  }

  /** Path part for operation `contentsRequestResultControllerFindById()` */
  static readonly ContentsRequestResultControllerFindByIdPath = '/api/contents-request-result/{id}';

  /**
   * 콘텐츠 의뢰 산출물 ID 기반 조회.
   *
   * 콘텐츠 의뢰 산출물을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerFindById$Response(params: ContentsRequestResultControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestResultDto>> {
    return contentsRequestResultControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 산출물 ID 기반 조회.
   *
   * 콘텐츠 의뢰 산출물을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerFindById(params: ContentsRequestResultControllerFindById$Params, context?: HttpContext): Observable<ContentsRequestResultDto> {
    return this.contentsRequestResultControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestResultDto>): ContentsRequestResultDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestResultControllerDelete()` */
  static readonly ContentsRequestResultControllerDeletePath = '/api/contents-request-result/{id}';

  /**
   * 콘텐츠 의뢰 산출물 삭제.
   *
   * 콘텐츠 의뢰 산출물을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerDelete$Response(params: ContentsRequestResultControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestResultDto>> {
    return contentsRequestResultControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 산출물 삭제.
   *
   * 콘텐츠 의뢰 산출물을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestResultControllerDelete(params: ContentsRequestResultControllerDelete$Params, context?: HttpContext): Observable<ContentsRequestResultDto> {
    return this.contentsRequestResultControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestResultDto>): ContentsRequestResultDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestResultControllerUpdate()` */
  static readonly ContentsRequestResultControllerUpdatePath = '/api/contents-request-result/{id}';

  /**
   * 콘텐츠 의뢰 산출물 수정.
   *
   * 콘텐츠 의뢰 산출물을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestResultControllerUpdate$Response(params: ContentsRequestResultControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestResultDto>> {
    return contentsRequestResultControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 산출물 수정.
   *
   * 콘텐츠 의뢰 산출물을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestResultControllerUpdate(params: ContentsRequestResultControllerUpdate$Params, context?: HttpContext): Observable<ContentsRequestResultDto> {
    return this.contentsRequestResultControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestResultDto>): ContentsRequestResultDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestResultControllerCreate()` */
  static readonly ContentsRequestResultControllerCreatePath = '/api/contents-request-result/{contentsRequestId}';

  /**
   * 콘텐츠 의뢰 산출물 생성.
   *
   * 콘텐츠 의뢰 산출물을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestResultControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestResultControllerCreate$Response(params: ContentsRequestResultControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestResultDto>> {
    return contentsRequestResultControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 산출물 생성.
   *
   * 콘텐츠 의뢰 산출물을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestResultControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestResultControllerCreate(params: ContentsRequestResultControllerCreate$Params, context?: HttpContext): Observable<ContentsRequestResultDto> {
    return this.contentsRequestResultControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestResultDto>): ContentsRequestResultDto => r.body)
    );
  }

}
